var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: _vm.profId } },
    [
      _c("base-card", { staticClass: "mb-4" }, [
        _c("div", { staticClass: "main-block" }, [
          _c("div", { staticClass: "media-block" }, [
            _c("img", {
              staticClass: "search-photo mb-3",
              attrs: { src: _vm.photo }
            }),
            _vm._v(" "),
            _vm.rating.total > 0
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "rating" },
                    [
                      _vm._l(5, function(n) {
                        return _c(
                          "span",
                          { key: "rating-" + n },
                          [
                            _c(_vm.ratingComponent(n), {
                              tag: "component",
                              attrs: { "font-scale": "1.3" }
                            }),
                            _vm._v(" \n            ")
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      !_vm.xlScreen
                        ? _c("span", {
                            staticClass: "rating-mobile",
                            domProps: {
                              innerHTML: _vm._s("(" + _vm.rating.total + ")")
                            }
                          })
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.xlScreen
                    ? _c("label", {
                        staticClass: "califications",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.rating.total + " " + _vm.$t("ratings")
                          )
                        }
                      })
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.xlScreen
              ? _c(
                  "div",
                  { staticClass: "mt-3" },
                  [
                    _c(
                      "base-button",
                      {
                        staticClass: "request-companies-appointment",
                        on: { click: _vm.defaultServiceAction }
                      },
                      [_vm._v(_vm._s(_vm.defaultServiceTitle))]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-block" }, [
            _c("div", [
              _c(
                "a",
                {
                  staticClass: "search-name",
                  attrs: {
                    href: _vm.$helpers.getCustomPageUrl(_vm.customPageUrl),
                    target: "_blank"
                  }
                },
                [_vm._v(_vm._s(_vm.name + " " + _vm.surnames))]
              )
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "specialties-list mt-2" },
              _vm._l(_vm.specialties, function(item) {
                return _c("li", {
                  key: item.id,
                  staticClass: "mr-3 mb-3",
                  domProps: {
                    innerHTML: _vm._s(_vm.$i18nHelpers.normalize(item.name))
                  }
                })
              }),
              0
            ),
            _vm._v(" "),
            _vm.subspecialtiesToShow.length > 0
              ? _c("div", [
                  _c(
                    "ul",
                    { staticClass: "subspecialties-list" },
                    [
                      _c("b", { staticClass: "inline-block mr-3 mb-3" }, [
                        _vm._v(_vm._s(_vm.$t("specialistInSearh")))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.subspecialtiesToShow, function(item) {
                        return _c(
                          "li",
                          _vm._g(
                            {
                              key: item.id,
                              staticClass: "mr-3 mb-3",
                              class: item.id === -1 ? "clickable" : null,
                              domProps: {
                                innerHTML: _vm._s(
                                  "" +
                                    (item.id === -1
                                      ? item.name
                                      : _vm.$i18nHelpers.normalize(item.name))
                                )
                              }
                            },
                            item.id === -1
                              ? { click: _vm.showMoreSubspecialties }
                              : {}
                          )
                        )
                      })
                    ],
                    2
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.introductoryText
              ? _c("p", {
                  staticClass: "introductory-text",
                  domProps: { innerHTML: _vm._s(_vm.introductoryText) }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "languages-list" },
              _vm._l(_vm.languagesToShow, function(item) {
                return _c("li", { key: item.code, staticClass: "mr-3 mb-3" }, [
                  _c(
                    "span",
                    _vm._g(
                      {
                        class: item.code === -1 ? "clickable" : null,
                        domProps: { innerHTML: _vm._s(item.language) }
                      },
                      item.code === -1 ? { click: _vm.showMoreLanguages } : {}
                    )
                  )
                ])
              }),
              0
            ),
            _vm._v(" "),
            !_vm.xlScreen
              ? _c(
                  "div",
                  { staticClass: "mt-3" },
                  [
                    _c(
                      "base-button",
                      {
                        staticClass: "request-companies-appointment",
                        on: { click: _vm.defaultServiceAction }
                      },
                      [_vm._v(_vm._s(_vm.defaultServiceTitle))]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-700e9fce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-700e9fce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/search/companies/SearchCompaniesBlock.vue
// module id = 3790
// module chunks = 11